import moment from "moment";
import { DATE_FORMATS } from "./Constant";

export const getAge = (birthDate) => {
  return moment().diff(birthDate, "years");
};

export const getActualYear = () => {
  return new Date().getFullYear();
};

export const getActualDate = () => {
  return moment().format(DATE_FORMATS.middledash_ymd);
};

export const hasDateExceededXdays = (date, days) => {
  const today = moment();
  const xDaysAgo = today.subtract(days, "days");
  return moment(date).isBefore(xDaysAgo);
};

export const calcularDiasCalendario = (
  fechaInicio,
  fechaFin = moment().format("YYYY-MM-DD")
) => {
  const inicio = moment(fechaInicio, "YYYY-MM-DD");
  const fin = moment(fechaFin, "YYYY-MM-DD");
  const diasTranscurridos = fin.diff(inicio, "days");
  return diasTranscurridos;
};

export const calcularDiasLaborales = (startDate, endDate) => {
  let start = moment(startDate);
  let end = moment(endDate);
  let businessDaysCount = 0;

  // Itera a través de las fechas
  while (start.isSameOrBefore(end, "day")) {
    // Si no es sábado (6) ni domingo (0), contar como día laboral
    if (start.isoWeekday() !== 6 && start.isoWeekday() !== 7) {
      businessDaysCount++;
    }
    start.add(1, "days");
  }

  return businessDaysCount;
};
